import React, { useState } from 'react';
import AccountDetails from '../Profile/AccountDetails';
import './OrganizerSettings.css';

const SETTINGS_TABS = [
  { id: 'account', label: 'Account' },
  { id: 'preferences', label: 'Preferences' },
  { id: 'payment', label: 'Payment' }
];

const OrganizerSettings = () => {
  const [activeTab, setActiveTab] = useState('account');

  return (
    <div className="org-settings">
      <h1 className="org-settings-title">Settings</h1>

      <div className="org-settings-tabs" role="tablist" aria-label="Settings sections">
        {SETTINGS_TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.id}
            className={`org-settings-tab ${activeTab === tab.id ? 'org-settings-tab--active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="org-settings-panel" role="tabpanel">
        {activeTab === 'account' ? <AccountDetails /> : null}
        {activeTab === 'preferences' ? (
          <p className="org-settings-placeholder">
            Preferences will be available here soon.
          </p>
        ) : null}
        {activeTab === 'payment' ? (
          <p className="org-settings-placeholder">
            Payment settings will be available here soon.
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default OrganizerSettings;
